module.exports = __webpack_public_path__ + "static/the-switch-opportunity-af2abf792262ef03b623fbdd1434e717.jpg";